import "../components/styles.css";
import React from "react";
import CalendarPicker from "../components/calendar-picker";
import Time from "../components/time";

export default function HoursSpanned({
  onSelectedDateFrom,
  dateFrom,
  onSelectedDateTo,
  dateTo,
  is24HoursFormat,
  timeFrom,
  timeTo,
  onSelectTimeTo,
  onSelectTimeFrom,
}) {
  return (
    <>
      <div className="check-in-out-container" id="hours-spanned-from-container">
        <CalendarPicker
          label={"From"}
          isStanAlone={false}
          onSelected={(value, str) => onSelectedDateFrom(value, str)}
          value={dateFrom}
          id="hours-spanned-calendar-from-component"
        />
        <Time
          label={"Time"}
          ampm={!is24HoursFormat}
          value={timeFrom}
          onChange={(value) => onSelectTimeFrom?.(value)}
          id="hours-spanned-time-from-component"
        />
      </div>
      <div className="check-in-out-container" id="hours-spanned-to-container">
        <CalendarPicker
          label={"To"}
          isStanAlone={false}
          onSelected={(value, str) => onSelectedDateTo(value, str)}
          value={dateTo}
          id="hours-spanned-calendar-to-component"
        />
        <Time
          label={"Time"}
          ampm={!is24HoursFormat}
          value={timeTo}
          onChange={(value) => onSelectTimeTo?.(value)}
          id="hours-spanned-time-to-component"
        />
      </div>
    </>
  );
}
